module.exports = __webpack_public_path__ + "img/2_ku.4dd39056.jpg";